import React, { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import RouteLoadingFallback from '../../common/RouteLoadingFallback';

/**
 * Outlet for a project section (Discover, Understand, Operate). The section's
 * nav stays mounted while a child page's chunk loads; only the page area
 * shows a skeleton. The boundary is keyed by full pathname so a switch to a
 * not-yet-loaded tab shows its skeleton at once instead of holding the old tab.
 */
const SectionOutlet: React.FC<{ section?: string }> = () => {
  const { pathname } = useLocation();
  return (
    <Suspense key={pathname} fallback={<RouteLoadingFallback variant="section" />}>
      <Outlet />
    </Suspense>
  );
};

export default SectionOutlet;
